import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.analysis.detail');
import { OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Service } from "src/libs/portal/season/service";

declare let WizRoute: any;
declare let wiz: any;

@Component({
    selector: 'wiz-page-analysis-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.analysis.detail/view.scss */
:host {
  --teal-900: #115e59;
  --teal-600: #0f766e;
  --teal-400: #0f766e;
  --teal-200: #5eead4;
  --teal-100: #ccfbf1;
  --teal-50: #ecfdf5;
  --page-bg: #f6f8fb;
  --panel-bg: #ffffff;
  --bg-secondary: #f8fafc;
  --text-primary: #111827;
  --text-secondary: #5b6472;
  --text-tertiary: #8a94a6;
  --border: #e5e7eb;
  --border-soft: #edf0f3;
  display: block;
  min-height: 100%;
  background: var(--page-bg);
}

.analysis-page {
  max-width: 1400px;
  margin: 0 auto;
  padding: 18px 24px 60px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  color: #111827;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
}

.state-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 60px 20px;
  font-size: 12px;
  color: #8a94a6;
}

.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 36px 20px;
  font-size: 12px;
  color: #8a94a6;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  background: #f8fafc;
}

.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 18px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
}

.top-bar-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.top-bar-meta {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.top-bar-title {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.top-bar-title .title-text {
  font-size: 17px;
  font-weight: 600;
  color: #111827;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
}

.top-bar-sub {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  font-size: 11px;
  color: #8a94a6;
}
.top-bar-sub span {
  display: inline-flex;
  align-items: center;
}

.top-bar-right {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.project-tabs {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
}

.project-tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 34px;
  padding: 0 13px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #5b6472;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: 0.14s ease;
}

.project-tab:hover {
  background: #f8fafc;
  color: #111827;
}

.project-tab.is-active {
  border-color: #ccfbf1;
  background: #ecfdf5;
  color: #115e59;
}

.project-tab i {
  font-size: 11px;
}

.dday-pill {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 9px;
  border-radius: 999px;
  background: #edf0f3;
  font-size: 11px;
  font-weight: 500;
}
.dday-pill.text-red-500 {
  background: #fee2e2;
  color: #dc2626;
}
.dday-pill.text-orange-500 {
  background: #ffedd5;
  color: #ea580c;
}
.dday-pill.text-yellow-600 {
  background: #fef9c3;
  color: #ca8a04;
}
.dday-pill.text-emerald-600 {
  background: #d1fae5;
  color: #059669;
}
.dday-pill.text-stone-400 {
  background: #edf0f3;
  color: #8a94a6;
}

.info-bar {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
}

.info-cell {
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.info-cell + .info-cell {
  border-left: 1px solid #e5e7eb;
}

.info-label {
  font-size: 10px;
  color: #8a94a6;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.info-value {
  font-size: 13px;
  font-weight: 500;
  color: #111827;
}

@media (max-width: 720px) {
  .info-bar {
    grid-template-columns: repeat(2, 1fr);
  }
  .info-cell:nth-child(3) {
    border-left: 0;
    border-top: 1px solid #e5e7eb;
  }
  .info-cell:nth-child(4) {
    border-top: 1px solid #e5e7eb;
  }
}
.step-rail {
  display: flex;
  align-items: center;
  padding: 14px 18px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  gap: 0;
}

.step-item {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
}

.step-num {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  background: #edf0f3;
  color: #8a94a6;
  border: 1.5px solid #e5e7eb;
  transition: all 0.2s;
}

.step-body {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.step-title {
  font-size: 12px;
  font-weight: 500;
  color: #5b6472;
  line-height: 1.2;
}

.step-meta {
  font-size: 10px;
  color: #8a94a6;
  line-height: 1.2;
}

.step-item.step-active .step-num {
  background: #0f766e;
  color: #fff;
  border-color: #0f766e;
  box-shadow: 0 0 0 4px #ecfdf5;
}
.step-item.step-active .step-title {
  color: #115e59;
}

.step-item.step-done .step-num {
  background: #d1fae5;
  color: #047857;
  border-color: #a7f3d0;
}
.step-item.step-done .step-title {
  color: #5b6472;
}

.step-bridge {
  flex: 1;
  height: 2px;
  background: #edf0f3;
  margin: 0 12px;
  min-width: 20px;
  border-radius: 1px;
}

@media (max-width: 720px) {
  .step-rail {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  .step-item {
    width: 100%;
  }
  .step-bridge {
    width: 2px;
    height: 12px;
    margin: 0 0 0 13px;
  }
}
.main-grid {
  display: grid;
  grid-template-columns: 380px minmax(0, 1fr);
  gap: 14px;
  align-items: start;
}

@media (max-width: 1024px) {
  .main-grid {
    grid-template-columns: 1fr;
  }
}
.left-pane {
  position: sticky;
  top: 14px;
}

@media (max-width: 1024px) {
  .left-pane {
    position: static;
  }
}
.panel {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
}

.panel-flush {
  padding-bottom: 0;
}

.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  gap: 8px;
}

.panel-head-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.panel-head-right {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.panel-title {
  font-size: 13px;
  font-weight: 500;
  color: #111827;
}

.panel-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  background: #edf0f3;
  color: #5b6472;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 500;
}

.btn-primary, .btn-danger, .btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 32px;
  padding: 0 14px;
  background: #0f766e;
  color: #fff;
  border: 0;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}
.btn-primary:hover:not(:disabled), .btn-danger:hover:not(:disabled), .btn-secondary:hover:not(:disabled) {
  background: #115e59;
}
.btn-primary:disabled, .btn-danger:disabled, .btn-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-secondary {
  background: #ffffff;
  color: #0f766e;
  border: 1px solid #ccfbf1;
}
.btn-secondary:hover:not(:disabled) {
  background: #ecfdf5;
}

.btn-danger {
  background: #dc2626;
}
.btn-danger:hover:not(:disabled) {
  background: #b91c1c;
}

.btn-ghost {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  padding: 0 10px;
  background: #ffffff;
  color: #5b6472;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-ghost:hover:not(:disabled) {
  background: #edf0f3;
  color: #111827;
}
.btn-ghost:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-ghost.is-active {
  background: #ecfdf5;
  color: #0f766e;
  border-color: #ccfbf1;
}

.btn-sm {
  height: 28px;
  padding: 0 10px;
  font-size: 11px;
}

.btn-xs {
  height: 24px;
  padding: 0 8px;
  font-size: 11px;
}

.icon-btn {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  color: #5b6472;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}
.icon-btn:hover {
  background: #edf0f3;
  color: #111827;
}
.icon-btn.icon-btn-danger:hover {
  border-color: #fecaca;
  background: #fef2f2;
  color: #dc2626;
}

.icon-btn-ghost {
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #8a94a6;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}
.icon-btn-ghost:hover:not(:disabled) {
  background: #edf0f3;
  color: #111827;
}
.icon-btn-ghost:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.badge-num {
  margin-left: 4px;
  padding: 1px 6px;
  background: #0f766e;
  color: #fff;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 500;
}

.parse-progress {
  padding: 10px 16px;
  border-bottom: 1px solid #e5e7eb;
  background: #ecfdf5;
}

.parse-progress-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  color: #5b6472;
  margin-bottom: 6px;
}
.parse-progress-head span:first-child {
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.parse-progress-pct {
  color: #115e59;
  font-weight: 500;
}

.parse-progress-bar {
  height: 6px;
  background: rgba(15, 118, 110, 0.15);
  border-radius: 999px;
  overflow: hidden;
}

.parse-progress-fill {
  height: 100%;
  background: #0f766e;
  border-radius: 999px;
  transition: width 0.3s ease-out;
}

.file-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: calc(100vh - 380px);
  overflow-y: auto;
}

.file-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid #edf0f3;
  transition: background 0.12s;
}
.file-item:hover {
  background: #f8fafc;
}
.file-item:last-child {
  border-bottom: 0;
}

.file-icon {
  font-size: 18px;
  flex-shrink: 0;
  margin-top: 2px;
}

.file-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.file-name {
  font-size: 12px;
  font-weight: 500;
  color: #111827;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.file-actions {
  display: flex;
  gap: 3px;
  align-items: center;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.meta-tag {
  display: inline-flex;
  align-items: center;
  height: 17px;
  padding: 0 6px;
  background: #edf0f3;
  color: #5b6472;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
}

.meta-dim {
  font-size: 10px;
  color: #8a94a6;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  height: 17px;
  padding: 0 7px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 500;
}

.status-done {
  background: #d1fae5;
  color: #047857;
}

.status-error {
  background: #fee2e2;
  color: #dc2626;
}

.status-running {
  background: #ecfdf5;
  color: #0f766e;
}

.status-pending {
  background: #edf0f3;
  color: #8a94a6;
}

.workflow-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  gap: 8px;
}

.workflow-head-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.workflow-head-right {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.guide-panel {
  padding: 12px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
}

.guide-panel-label {
  font-size: 11px;
  font-weight: 500;
  color: #5b6472;
  margin-bottom: 8px;
}

.guide-empty {
  font-size: 12px;
  color: #8a94a6;
  padding: 8px 0;
}

.guide-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.guide-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 11px;
  color: #5b6472;
  cursor: pointer;
  transition: all 0.15s;
}
.guide-chip:hover {
  border-color: #ccfbf1;
}
.guide-chip.is-on {
  border-color: #0f766e;
  background: #ecfdf5;
  color: #115e59;
  font-weight: 500;
}

.guide-chip-cat {
  font-size: 9px;
  padding: 1px 5px;
  border-radius: 3px;
  font-weight: 500;
}

.state-idle {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 64px 24px;
}

.state-idle-title {
  font-size: 14px;
  font-weight: 500;
  color: #111827;
}

.state-idle-desc {
  font-size: 12px;
  color: #8a94a6;
  text-align: center;
  max-width: 360px;
  line-height: 1.5;
}

.stage-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 18px 20px 8px;
}

.stage-title {
  font-size: 14px;
  font-weight: 500;
  color: #111827;
}

.stage-desc {
  font-size: 12px;
  color: #8a94a6;
  padding: 0 20px 12px;
}

.stage-greeting {
  font-size: 12px;
  color: #5b6472;
  line-height: 1.6;
  padding: 4px 20px 16px;
}

.stage-interview {
  padding-bottom: 20px;
}

.interview-list {
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.interview-q {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.interview-q-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: wrap;
}

.interview-q-head-left {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

.interview-q-head-right {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
  flex-wrap: wrap;
}

.q-num {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  padding: 0 7px;
  background: #ecfdf5;
  color: #115e59;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
}

.q-text {
  font-size: 13px;
  font-weight: 500;
  color: #111827;
  line-height: 1.4;
}

.q-required {
  font-size: 10px;
  color: #dc2626;
  flex-shrink: 0;
  margin-top: 2px;
}

.q-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 12px;
  color: #111827;
  background: #ffffff;
  outline: 0;
  transition: border-color 0.15s;
}
.q-input:focus {
  border-color: #ccfbf1;
  box-shadow: 0 0 0 3px #ecfdf5;
}

.q-textarea {
  resize: vertical;
  min-height: 64px;
  font-family: inherit;
  line-height: 1.5;
}

.q-file-drop {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border: 1px dashed #e5e7eb;
  border-radius: 6px;
  background: #f8fafc;
  font-size: 12px;
  color: #5b6472;
  cursor: pointer;
  transition: all 0.15s;
}
.q-file-drop:hover {
  border-color: #ccfbf1;
  color: #115e59;
  background: #ecfdf5;
}

.q-file-status {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  font-size: 11px;
  color: #8a94a6;
}
.q-file-status.is-ok {
  color: #047857;
}
.q-file-status.is-err {
  color: #dc2626;
}

.ai-bubble {
  margin-top: 6px;
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 12px;
}
.ai-bubble p {
  margin: 0;
  line-height: 1.55;
  color: #5b6472;
  white-space: pre-wrap;
}

.ai-bubble-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 500;
}

.ai-bubble-head-left {
  display: flex;
  align-items: center;
  gap: 5px;
}

.ai-bubble-suggest {
  background: #ecfdf5;
  border: 1px solid rgba(15, 118, 110, 0.2);
}

.ai-bubble-suggest .ai-bubble-head {
  color: #115e59;
}

.ai-bubble-review {
  background: #fffbeb;
  border: 1px solid #fde68a;
}

.ai-bubble-review .ai-bubble-head {
  color: #b45309;
}

.interview-foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px 0;
  margin: 16px 20px 0 20px;
  border-top: 1px solid #e5e7eb;
  margin-left: 0;
  margin-right: 0;
  padding-left: 20px;
  padding-right: 20px;
}

.stage-analyzing {
  padding-bottom: 20px;
}

.progress-list {
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.progress-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 4px;
  border-bottom: 1px solid #edf0f3;
}
.progress-row:last-child {
  border-bottom: 0;
}
.progress-row.is-running .progress-icon {
  background: #ecfdf5;
  color: #0f766e;
}
.progress-row.is-running .progress-title {
  color: #115e59;
}
.progress-row.is-done .progress-icon {
  background: #d1fae5;
  color: #047857;
}
.progress-row.is-error .progress-icon {
  background: #fee2e2;
  color: #dc2626;
}
.progress-row.is-error .progress-title {
  color: #dc2626;
}

.progress-icon {
  width: 32px;
  height: 32px;
  background: #edf0f3;
  color: #8a94a6;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.progress-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.progress-title {
  font-size: 13px;
  font-weight: 500;
  color: #5b6472;
}

.progress-meta {
  font-size: 11px;
  color: #8a94a6;
}
.progress-meta.is-err {
  color: #dc2626;
}

.stage-done {
  padding-bottom: 24px;
}

.alert-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px 20px 0;
  padding: 10px 14px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
}

.alert-head {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #b91c1c;
  font-weight: 500;
}

.doc-cards {
  padding: 0 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
}

.doc-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
}
.doc-card:hover {
  border-color: #ccfbf1;
  box-shadow: 0 1px 6px rgba(15, 118, 110, 0.1);
  transform: translateY(-1px);
}
.doc-card.is-empty {
  opacity: 0.55;
  background: #f8fafc;
  cursor: default;
}
.doc-card.is-empty:hover {
  transform: none;
  box-shadow: none;
  border-color: #e5e7eb;
}

.doc-card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.doc-card-head-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.doc-card-icon {
  font-size: 14px;
  color: #0f766e;
}

.doc-card-title {
  font-size: 13px;
  font-weight: 500;
  color: #111827;
}

.doc-card-meta {
  font-size: 11px;
  color: #8a94a6;
}

.doc-card-actions {
  display: flex;
  gap: 8px;
  padding-top: 6px;
  border-top: 1px solid #edf0f3;
}

.card-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #5b6472;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  transition: color 0.12s;
}
.card-link:hover {
  color: #0f766e;
}
.card-link.card-link-danger:hover {
  color: #dc2626;
}

.doc-viewer {
  display: flex;
  flex-direction: column;
  min-height: 480px;
  padding-bottom: 20px;
}

.doc-viewer-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  gap: 8px;
}

.doc-viewer-head-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.doc-viewer-head-right {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.doc-viewer-icon {
  font-size: 14px;
  color: #0f766e;
}

.doc-viewer-title {
  font-size: 14px;
  font-weight: 500;
  color: #111827;
}

.doc-viewer-body {
  flex: 1;
  padding: 20px;
  overflow: auto;
}

.doc-viewer-edit {
  flex: 1;
  padding: 16px;
}

.doc-edit-textarea {
  width: 100%;
  min-height: 480px;
  padding: 14px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-family: "Menlo", "Consolas", monospace;
  font-size: 12px;
  line-height: 1.6;
  color: #111827;
  background: #f8fafc;
  outline: 0;
  resize: vertical;
}
.doc-edit-textarea:focus {
  border-color: #ccfbf1;
}

.overlay {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
}

.overlay-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
}

.overlay-pane {
  position: relative;
  margin-left: auto;
  width: min(88%, 1400px);
  height: 100%;
  background: #ffffff;
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
}

.overlay-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 18px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
  gap: 12px;
}

.overlay-head-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1;
}

.overlay-head-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.overlay-title {
  font-size: 13px;
  font-weight: 500;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pager {
  display: flex;
  align-items: center;
  gap: 4px;
}

.pager-label {
  font-size: 12px;
  color: #5b6472;
  font-weight: 500;
  min-width: 56px;
  text-align: center;
}

.overlay-body {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  overflow: hidden;
}

.overlay-pane-img {
  overflow: auto;
  border-right: 1px solid #e5e7eb;
  background: #f8fafc;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 20px;
}
.overlay-pane-img img {
  max-width: 100%;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
.overlay-pane-img .empty-block {
  background: transparent;
  border: 0;
  padding: 40px;
}

.overlay-pane-text {
  overflow: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.overlay-pane-text-head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.overlay-pre {
  font-family: -apple-system, "Segoe UI", sans-serif;
  font-size: 12px;
  line-height: 1.7;
  color: #5b6472;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
}

::ng-deep .md-content {
  font-size: 13px;
  color: #5b6472;
  line-height: 1.7;
}
::ng-deep .md-content .md-h1 {
  font-weight: 600;
  font-size: 16px;
  color: #111827;
  margin: 18px 0 10px;
}
::ng-deep .md-content .md-h2 {
  font-weight: 600;
  font-size: 14px;
  color: #111827;
  margin: 16px 0 8px;
  padding-bottom: 5px;
  border-bottom: 1px solid #e5e7eb;
}
::ng-deep .md-content .md-h3 {
  font-weight: 500;
  font-size: 13px;
  color: #111827;
  margin: 12px 0 5px;
}
::ng-deep .md-content .md-li {
  display: flex;
  gap: 8px;
  margin-left: 4px;
  padding: 2px 0;
}
::ng-deep .md-content .md-li > span:first-child {
  flex-shrink: 0;
  color: #0f766e;
  font-weight: 600;
  min-width: 18px;
}
::ng-deep .md-content .md-check {
  display: flex;
  gap: 8px;
  margin-left: 4px;
  padding: 2px 0;
}
::ng-deep .md-content .md-check > span:first-child {
  flex-shrink: 0;
}
::ng-deep .md-content .md-check.done > span:first-child {
  color: #059669;
}
::ng-deep .md-content .md-check.done > span:last-child {
  text-decoration: line-through;
  color: #8a94a6;
}
::ng-deep .md-content strong {
  font-weight: 600;
  color: #111827;
}
::ng-deep .md-content em {
  font-style: italic;
  color: #5b6472;
}
::ng-deep .md-content code {
  background: #ecfdf5;
  color: #115e59;
  padding: 1px 5px;
  border-radius: 4px;
  font-size: 12px;
  font-family: "Menlo", monospace;
}
::ng-deep .md-content table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
  font-size: 12px;
}
::ng-deep .md-content td, ::ng-deep .md-content th {
  padding: 6px 10px;
  border: 1px solid #e5e7eb;
  text-align: left;
}
::ng-deep .md-content tr:first-child td {
  font-weight: 600;
  background: #ecfdf5;
  color: #115e59;
}`],
})
export class PageAnalysisDetailComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( DomSanitizer)  private sanitizer: DomSanitizer) { }

    public notice_no: string = '';
    public item: any = null;
    public loading: boolean = true;
    public selectedDoc: any = null;
    public docViewerPage: number = 1;
    public docViewerTotalPages: number = 1;
    public docViewerPageText: string = '';
    public docViewerImageUrl: string = '';
    public docViewerIsPdf: boolean = false;
    public docViewerLoading: boolean = false;

    public parsing: boolean = false;
    public parseProgress: any = { current: 0, total: 0, fileName: '', status: '' };
    public parseResults: any[] = [];

    public guides: any[] = [];
    public selectedGuideIds: any = {};
    public showGuideSelector: boolean = false;

    public workflowStep: string = 'idle';
    public aiModel: string = 'qwen3.6:35b-a3b';

    public interviewData: any = null;
    public interviewAnswers: any = {};
    public interviewLoading: boolean = false;
    public interviewFileData: any = {};  // q_id -> { name, content } 파일 업로드 데이터
    public aiSuggesting: any = {};  // q_id -> boolean
    public aiSuggestions: any = {};  // q_id -> string
    public aiReviewing: any = {};  // q_id -> boolean
    public aiReviews: any = {};  // q_id -> string

    public analysisProgress: any[] = [];
    public analysisRunning: boolean = false;

    public planningDocs: any[] = [];
    public activeDocType: string = '';
    public activeDocContent: string = '';
    public activeDocId: string = '';
    public docEditing: boolean = false;
    public docEditContent: string = '';
    public docLoading: boolean = false;

    public aiResult: string = '';

    public DOC_TYPES: any = {
        rfp_summary: { label: 'RFP 분석 요약', icon: 'fa-file-lines', color: 'text-teal-700 bg-teal-50 border-teal-100' },
        toc: { label: '목차 설계', icon: 'fa-list-ol', color: 'text-emerald-600 bg-emerald-50 border-emerald-200' },
        req_map: { label: '요구사항 매핑표', icon: 'fa-table', color: 'text-rose-600 bg-rose-50 border-rose-200' },
    };

    public async ngOnInit() {
        await this.service.init();
        this.notice_no = WizRoute.segment.id || '';
        await this.loadGuides();
        await this.load();
        await this.loadPlanningDocs();
        await this.restoreInterviewState();
        await this.service.render();
    }

    ngOnDestroy() {
        if (this._interviewSaveTimer) clearTimeout(this._interviewSaveTimer);
        if (this._analysisPollTimer) clearInterval(this._analysisPollTimer);
    }

    // ── 인터뷰 진행 상태 자동 저장/복원 (FN-0011) ──
    private _interviewSaveTimer: any = null;

    public async restoreInterviewState() {
        try {
            let res = await wiz.call('get_interview_state', { notice_no: this.notice_no });
            if (res.code === 200 && res.data.state) {
                let s = res.data.state;
                if (s.workflowStep === 'interview' && s.interviewData) {
                    this.workflowStep = 'interview';
                    this.aiModel = s.aiModel || 'qwen3.6:35b-a3b';
                    this.interviewData = s.interviewData;
                    this.interviewAnswers = s.interviewAnswers || {};
                    this.aiSuggestions = s.aiSuggestions || {};
                    this.aiReviews = s.aiReviews || {};
                }
            }
        } catch { }
    }

    public scheduleInterviewSave() {
        if (this._interviewSaveTimer) clearTimeout(this._interviewSaveTimer);
        this._interviewSaveTimer = setTimeout(() => this.persistInterviewState(), 800);
    }

    public async persistInterviewState() {
        if (this.workflowStep !== 'interview' || !this.interviewData) return;
        try {
            await wiz.call('save_interview_state', {
                notice_no: this.notice_no,
                state: JSON.stringify({
                    workflowStep: this.workflowStep,
                    aiModel: this.aiModel,
                    interviewData: this.interviewData,
                    interviewAnswers: this.interviewAnswers,
                    aiSuggestions: this.aiSuggestions,
                    aiReviews: this.aiReviews,
                }),
            });
        } catch { }
    }

    public onInterviewAnswerChange() {
        this.scheduleInterviewSave();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        try {
            let res = await wiz.call("get_notice", { notice_no: this.notice_no });
            if (res.code === 200) {
                this.item = res.data.item;
                let aiDoc = (this.item.documents || []).find((d: any) => d.ai_status === 'done' && d.ai_analysis);
                if (aiDoc) { this.aiResult = aiDoc.ai_analysis; this.aiModel = aiDoc.ai_model || 'qwen3.6:35b-a3b'; }
            }
        } catch { }
        this.loading = false;
        await this.service.render();
    }

    public goBack() {
        if (this.isProjectEntry()) {
            this.service.href('/proposal');
            return;
        }
        this.service.href('/analysis');
    }

    private isProjectEntry(): boolean {
        try {
            const params = new URLSearchParams(window.location.search || '');
            return params.get('from') === 'project' || params.get('entry') === 'project';
        } catch {
            return false;
        }
    }

    public goProposal() { this.service.href(`/proposal/${encodeURIComponent(this.notice_no)}`); }
    public goPresentation() { this.service.href(`/presentation?notice_no=${encodeURIComponent(this.notice_no)}`); }

    public uploadingAttachment: boolean = false;

    public get isManual(): boolean { return this.item?.source === 'manual'; }

    public async downloadFile(att: any) {
        let doc = this.getDocStatus(att.name);
        let docId = att.doc_id || (doc ? doc.id : '');
        if (!docId) return;
        try {
            let formData = new FormData();
            formData.append('doc_id', docId);
            let res = await fetch(wiz.url('download_attachment'), { method: 'POST', body: formData });
            if (!res.ok) return;
            let blob = await res.blob();
            let url = URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = att.name || 'file';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (e: any) {
            console.error('[downloadFile] error:', e);
        }
    }

    public async deleteAttachment(att: any) {
        let doc = this.getDocStatus(att.name);
        let docId = att.doc_id || (doc ? doc.id : '');
        if (!docId) return;
        if (!confirm(`"${att.name}" 파일을 삭제하시겠습니까?`)) return;
        try {
            let result = await wiz.call("delete_attachment", { doc_id: docId });
            if (result.code === 200) {
                await this.load();
            }
        } catch (e: any) {
            console.error('[deleteAttachment] error:', e);
        }
    }

    public async onAttachmentUpload(event: any) {
        let files: File[] = Array.from(event.target.files || []);
        if (files.length === 0) return;
        this.uploadingAttachment = true;
        await this.service.render();
        try {
            let formData = new FormData();
            formData.append('notice_no', this.notice_no);
            for (let f of files) formData.append('file', f);
            let res = await fetch(wiz.url('upload_attachment'), { method: 'POST', body: formData });
            let data = await res.json();
            if (data.code === 200) {
                await this.load();
            } else {
                alert(data.data?.message || '업로드 실패');
            }
        } catch (e: any) {
            alert(e.message || '업로드 실패');
        }
        this.uploadingAttachment = false;
        await this.service.render();
    }

    public get parsableFiles() { return (this.item?.attachments || []).filter((a: any) => this.isParsable(a.name)); }
    public get parsePercent() { if (this.parseProgress.total === 0) return 0; return Math.round((this.parseProgress.current / this.parseProgress.total) * 100); }
    public get parsedDocCount(): number {
        return (this.item?.documents || []).filter((d: any) => d.status === 'done').length;
    }

    // ── Step indicator ──────────────────────────────
    public get currentStepIndex(): number {
        // 1: 파일 파싱 / 2: 사전 인터뷰 / 3: AI 분석 / 4: 결과 검토
        if (this.workflowStep === 'analyzing') return 3;
        if (this.workflowStep === 'interview') return 2;
        if (this.workflowStep === 'done' && this.allPlanningDone()) return 4;
        if (this.workflowStep === 'done') return 4;
        if (this.hasParsedDocs) return 2;
        return 1;
    }
    public stepStatus(idx: number): string {
        const cur = this.currentStepIndex;
        if (idx < cur) return 'done';
        if (idx === cur) return 'active';
        return 'pending';
    }

    public async parseAll() {
        let files = this.parsableFiles;
        if (files.length === 0) { alert('분석 가능한 첨부파일이 없습니다.'); return; }
        this.parsing = true; this.parseResults = []; this.parseProgress = { current: 0, total: files.length, fileName: '', status: '파싱 준비 중...' };
        await this.service.render();
        for (let i = 0; i < files.length; i++) {
            let att = files[i]; let doc = this.getDocStatus(att.name);
            if (doc && doc.status === 'done') { this.parseProgress.current = i + 1; this.parseProgress.fileName = att.name; this.parseResults.push({ file_name: att.name, status: 'done' }); await this.service.render(); continue; }
            this.parseProgress.current = i; this.parseProgress.fileName = att.name; this.parseProgress.status = '파싱 중...'; await this.service.render();
            try {
                let res: any;
                if (att.manual && att.doc_id) {
                    res = await wiz.call("parse_uploaded", { doc_id: att.doc_id });
                } else {
                    res = await wiz.call("analyze_single", { notice_no: this.notice_no, file_name: att.name, file_url: att.url });
                }
                this.parseProgress.current = i + 1;
                this.parseResults.push(res.code === 200 ? { file_name: att.name, status: 'done', ...res.data } : { file_name: att.name, status: 'error', message: res.data?.message || '오류' });
            } catch (e: any) { this.parseProgress.current = i + 1; this.parseResults.push({ file_name: att.name, status: 'error', message: e.message }); }
            await this.service.render();
        }
        this.parseProgress.status = '완료'; this.parsing = false; await this.load();
    }

    public async parseSingle(att: any) {
        if (this.parsing) return;
        this.parsing = true; this.parseResults = []; this.parseProgress = { current: 0, total: 1, fileName: att.name, status: '파싱 중...' }; await this.service.render();
        try {
            let res: any;
            if (att.manual && att.doc_id) {
                res = await wiz.call("parse_uploaded", { doc_id: att.doc_id });
            } else {
                res = await wiz.call("analyze_single", { notice_no: this.notice_no, file_name: att.name, file_url: att.url });
            }
            this.parseProgress.current = 1;
            this.parseResults = [res.code === 200 ? { file_name: att.name, status: 'done', ...res.data } : { file_name: att.name, status: 'error', message: res.data?.message }];
        } catch (e: any) { this.parseProgress.current = 1; this.parseResults = [{ file_name: att.name, status: 'error', message: e.message }]; }
        this.parsing = false; await this.load();
    }

    public async loadGuides() { try { let res = await wiz.call("load_guides"); if (res.code === 200) this.guides = res.data.guides || []; } catch { } }
    public async toggleGuideSelector() { this.showGuideSelector = !this.showGuideSelector; await this.service.render(); }
    public async toggleGuide(id: string) { this.selectedGuideIds[id] = !this.selectedGuideIds[id]; await this.service.render(); }
    public get selectedGuideCount() { return Object.values(this.selectedGuideIds).filter(v => v).length; }
    public getSelectedGuideIdList(): string { return Object.keys(this.selectedGuideIds).filter(k => this.selectedGuideIds[k]).join(','); }
    public getCategoryLabel(cat: string) { const m: any = { analysis: 'RFP 분석', proposal: '제안서', presentation: '발표자료', chat: '어시스턴트', general: '공통' }; return m[cat] || cat; }
    public getCategoryColor(cat: string) { const m: any = { analysis: 'bg-teal-50 text-teal-700', proposal: 'bg-emerald-100 text-emerald-700', presentation: 'bg-purple-100 text-purple-700', chat: 'bg-amber-100 text-amber-700', general: 'bg-stone-100 text-stone-600' }; return m[cat] || 'bg-stone-100 text-stone-600'; }

    public get hasParsedDocs(): boolean { return (this.item?.documents || []).some((d: any) => d.status === 'done'); }

    public async startWorkflow(model: string = 'qwen3.6:35b-a3b') {
        if (!this.hasParsedDocs) { alert('먼저 첨부파일 파싱을 완료해주세요.'); return; }
        this.aiModel = model; this.workflowStep = 'interview'; this.interviewLoading = true; this.interviewData = null; this.interviewAnswers = {}; this.interviewFileData = {}; this.aiSuggesting = {}; this.aiSuggestions = {}; this.aiReviewing = {}; this.aiReviews = {};
        await this.service.render();
        try {
            let res = await wiz.call("start_interview", { notice_no: this.notice_no, model: model, guide_ids: this.getSelectedGuideIdList() });
            if (res.code === 200) {
                this.interviewData = res.data.interview;
                if (this.interviewData?.questions) { for (let q of this.interviewData.questions) { this.interviewAnswers[q.id] = q.default || ''; } }
                this.persistInterviewState();
            } else { this.workflowStep = 'idle'; }
        } catch { this.workflowStep = 'idle'; }
        this.interviewLoading = false; await this.service.render();
    }

    public async skipInterview() { await this.runAnalysis(); }

    public async submitInterview() {
        let lines: string[] = ['# 사전 인터뷰 결과\n'];
        if (this.interviewData?.questions) {
            for (let q of this.interviewData.questions) {
                lines.push(`## ${q.question}`);
                if (q.type === 'file' && this.interviewFileData[q.id]) {
                    let fileInfo = this.interviewFileData[q.id];
                    lines.push(`[업로드된 파일: ${fileInfo.name}]`);
                    if (fileInfo.content) lines.push(fileInfo.content);
                } else {
                    lines.push(this.interviewAnswers[q.id] || '(미응답)');
                }
                lines.push('');
            }
        }
        try { await wiz.call("save_interview", { notice_no: this.notice_no, answers: lines.join('\n') }); } catch { }
        try { await wiz.call("clear_interview_state", { notice_no: this.notice_no }); } catch { }
        await this.runAnalysis();
    }

    public async onInterviewFileUpload(event: any, questionId: string) {
        let file = event.target?.files?.[0];
        if (!file) return;
        this.interviewFileData[questionId] = { name: file.name, uploading: true, content: '' };
        this.interviewAnswers[questionId] = `파일 업로드 중: ${file.name}`;
        await this.service.render();
        try {
            let fd = new FormData();
            fd.append('file', file);
            fd.append('notice_no', this.notice_no);
            fd.append('question_id', questionId);
            let resp = await fetch(wiz.url('upload_reference_file'), { method: 'POST', body: fd });
            let res = await resp.json();
            if (res.code === 200) {
                this.interviewFileData[questionId] = { name: file.name, uploading: false, content: res.data.content || '' };
                this.interviewAnswers[questionId] = `업로드됨: ${file.name}`;
            } else {
                this.interviewFileData[questionId] = { name: file.name, uploading: false, error: res.data?.message || '업로드 실패' };
                this.interviewAnswers[questionId] = `업로드 실패: ${res.data?.message || '오류'}`;
            }
        } catch (e: any) {
            this.interviewFileData[questionId] = { name: file.name, uploading: false, error: e.message };
            this.interviewAnswers[questionId] = `업로드 실패: ${e.message}`;
        }
        await this.service.render();
    }

    public async aiSuggestAnswer(questionId: string, questionText: string) {
        this.aiSuggesting[questionId] = true;
        await this.service.render();
        try {
            let res = await wiz.call("ai_suggest_answer", { notice_no: this.notice_no, question: questionText, model: this.aiModel });
            if (res.code === 200) {
                this.aiSuggestions[questionId] = res.data.suggestion || '';
            } else {
                this.aiSuggestions[questionId] = `오류: ${res.data?.message || '추천 실패'}`;
            }
        } catch (e: any) {
            this.aiSuggestions[questionId] = `오류: ${e.message}`;
        }
        this.aiSuggesting[questionId] = false;
        await this.service.render();
    }

    public async aiReviewAnswer(questionId: string, questionText: string) {
        let answer = this.interviewAnswers[questionId] || '';
        if (!answer.trim()) {
            alert('검토할 답변을 먼저 입력해주세요.');
            return;
        }
        this.aiReviewing[questionId] = true;
        await this.service.render();
        try {
            let res = await wiz.call("ai_review_answer", { notice_no: this.notice_no, question: questionText, answer: answer, model: this.aiModel });
            if (res.code === 200) {
                this.aiReviews[questionId] = res.data.review || '';
            } else {
                this.aiReviews[questionId] = `오류: ${res.data?.message || '검토 실패'}`;
            }
        } catch (e: any) {
            this.aiReviews[questionId] = `오류: ${e.message}`;
        }
        this.aiReviewing[questionId] = false;
        await this.service.render();
    }

    public applySuggestion(questionId: string) {
        if (this.aiSuggestions[questionId]) {
            this.interviewAnswers[questionId] = this.aiSuggestions[questionId];
            this.aiSuggestions[questionId] = '';
            this.service.render();
        }
    }

    public async runAnalysis() {
        this.workflowStep = 'analyzing'; this.analysisRunning = true;
        this.analysisProgress = [
            { key: 'rfp_summary', label: 'RFP 분석 요약', status: 'pending', icon: 'fa-file-lines' },
            { key: 'toc', label: '목차 설계', status: 'pending', icon: 'fa-list-ol' },
            { key: 'req_map', label: '요구사항 매핑표', status: 'pending', icon: 'fa-table' },
        ];
        await this.service.render();
        // 서버에서 전체 단계를 한 번에 실행 (브라우저 이탈해도 서버 계속 실행).
        // 프론트는 동시에 polling으로 상태만 업데이트.
        wiz.call("run_guided_analysis", { notice_no: this.notice_no, model: this.aiModel, guide_ids: this.getSelectedGuideIdList(), step: "" })
            .then(async (res: any) => {
                if (this._analysisPollTimer) { clearInterval(this._analysisPollTimer); this._analysisPollTimer = null; }
                await this.refreshAnalysisProgressFromDb();
                this.analysisRunning = false; this.workflowStep = 'done';
                await this.loadPlanningDocs(); await this.service.render();
            })
            .catch(async (e: any) => {
                if (this._analysisPollTimer) { clearInterval(this._analysisPollTimer); this._analysisPollTimer = null; }
                // 네트워크 오류도 서버는 진행 중일 수 있음 → DB 상태 갱신 후 마무리
                await this.refreshAnalysisProgressFromDb();
                this.analysisRunning = false; this.workflowStep = 'done';
                await this.loadPlanningDocs(); await this.service.render();
            });
        this.startAnalysisPolling();
    }

    // ── 분석 진행 폴링 (FN-0012) ──
    private _analysisPollTimer: any = null;

    public startAnalysisPolling() {
        if (this._analysisPollTimer) clearInterval(this._analysisPollTimer);
        this._analysisPollTimer = setInterval(async () => {
            await this.refreshAnalysisProgressFromDb();
        }, 2500);
    }

    public async refreshAnalysisProgressFromDb() {
        try {
            let res = await wiz.call("get_planning_docs", { notice_no: this.notice_no });
            if (res.code !== 200) return;
            let docs = res.data.docs || [];
            for (let step of this.analysisProgress) {
                let d = docs.find((x: any) => x.doc_type === step.key);
                if (!d) continue;
                if (d.status === 'done') step.status = 'done';
                else if (d.status === 'generating') step.status = 'running';
                else if (d.status === 'error') step.status = 'error';
            }
            // 모든 단계가 done/error로 종료되면 폴링 중단
            let allEnded = this.analysisProgress.every((s: any) => s.status === 'done' || s.status === 'error');
            if (allEnded && this._analysisPollTimer) {
                clearInterval(this._analysisPollTimer);
                this._analysisPollTimer = null;
                this.analysisRunning = false;
                this.workflowStep = 'done';
                await this.loadPlanningDocs();
            }
            await this.service.render();
        } catch { }
    }

    public get hasFailedSteps(): boolean {
        return this.analysisProgress.some((s: any) => s.status === 'error');
    }

    public async retryFailedSteps() {
        this.workflowStep = 'analyzing';
        this.analysisRunning = true;
        await this.service.render();
        for (let step of this.analysisProgress) {
            if (step.status !== 'error') continue;
            step.status = 'running'; step.error = ''; await this.service.render();
            try {
                let res = await wiz.call("run_guided_analysis", { notice_no: this.notice_no, model: this.aiModel, guide_ids: this.getSelectedGuideIdList(), step: step.key });
                step.status = res.code === 200 ? 'done' : 'error';
                if (res.code !== 200) {
                    let errDetail = res.data?.errors?.[step.key] || res.data?.message || '실패';
                    step.error = errDetail;
                }
            } catch (e: any) { step.status = 'error'; step.error = e.message; }
            await this.service.render();
        }
        this.analysisRunning = false; this.workflowStep = 'done';
        await this.loadPlanningDocs(); await this.service.render();
    }

    public async loadPlanningDocs() {
        try {
            let res = await wiz.call("get_planning_docs", { notice_no: this.notice_no });
            if (res.code === 200) {
                this.planningDocs = res.data.docs || [];
                if (this.planningDocs.some((d: any) => d.status === 'done') && this.workflowStep === 'idle') this.workflowStep = 'done';
                // FN-0012: 페이지 재진입 시 generating 상태 감지 → 폴링 재개
                let inProgress = this.planningDocs.some((d: any) => d.status === 'generating');
                if (inProgress && this.workflowStep !== 'analyzing') {
                    this.workflowStep = 'analyzing';
                    this.analysisRunning = true;
                    this.analysisProgress = [
                        { key: 'rfp_summary', label: 'RFP 분석 요약', status: 'pending', icon: 'fa-file-lines' },
                        { key: 'toc', label: '목차 설계', status: 'pending', icon: 'fa-list-ol' },
                        { key: 'req_map', label: '요구사항 매핑표', status: 'pending', icon: 'fa-table' },
                    ];
                    for (let step of this.analysisProgress) {
                        let d = this.planningDocs.find((x: any) => x.doc_type === step.key);
                        if (d) {
                            if (d.status === 'done') step.status = 'done';
                            else if (d.status === 'generating') step.status = 'running';
                            else if (d.status === 'error') step.status = 'error';
                        }
                    }
                    this.startAnalysisPolling();
                }
            }
        } catch { }
    }

    public getPlanningDoc(docType: string) { return this.planningDocs.find((d: any) => d.doc_type === docType); }

    public allPlanningDone(): boolean {
        const required = ['rfp_summary', 'toc', 'req_map'];
        return required.every(dt => {
            const doc = this.getPlanningDoc(dt);
            return doc && doc.status === 'done';
        });
    }

    public async openDoc(docType: string) {
        let doc = this.getPlanningDoc(docType); if (!doc) return;
        this.activeDocType = docType; this.activeDocId = doc.id; this.docLoading = true; this.docEditing = false; await this.service.render();
        try { let res = await wiz.call("get_planning_doc", { doc_id: doc.id }); if (res.code === 200) this.activeDocContent = res.data.doc.content || ''; } catch { }
        this.docLoading = false; await this.service.render();
    }

    public async closeDoc() { this.activeDocType = ''; this.activeDocContent = ''; this.activeDocId = ''; this.docEditing = false; await this.service.render(); }
    public async startEditDoc() { this.docEditContent = this.activeDocContent; this.docEditing = true; await this.service.render(); }
    public async cancelEditDoc() { this.docEditing = false; await this.service.render(); }

    public async saveDoc() {
        try { let res = await wiz.call("update_planning_doc", { doc_id: this.activeDocId, content: this.docEditContent }); if (res.code === 200) { this.activeDocContent = this.docEditContent; this.docEditing = false; await this.loadPlanningDocs(); } } catch { }
        await this.service.render();
    }

    public async deleteDoc(docType: string, event: Event) {
        event.stopPropagation(); let doc = this.getPlanningDoc(docType); if (!doc) return;
        if (!confirm(`"${this.DOC_TYPES[docType]?.label}" 문서를 삭제하시겠습니까?`)) return;
        try { let res = await wiz.call("delete_planning_doc", { doc_id: doc.id }); if (res.code === 200) { if (this.activeDocType === docType) await this.closeDoc(); await this.loadPlanningDocs(); } } catch { }
        await this.service.render();
    }

    public async regenerateDoc(docType: string) {
        if (!confirm(`"${this.DOC_TYPES[docType]?.label}"을 AI로 다시 생성하시겠습니까?`)) return;
        this.docLoading = true; await this.service.render();
        try {
            let res = await wiz.call("run_guided_analysis", { notice_no: this.notice_no, model: this.aiModel, guide_ids: this.getSelectedGuideIdList(), step: docType });
            if (res.code === 200) {
                await this.loadPlanningDocs();
                await this.openDoc(docType);
            } else {
                let errDetail = res.data?.errors?.[docType] || res.data?.message || '재생성에 실패했습니다.';
                alert(errDetail);
            }
        } catch (e: any) {
            alert(e.message || '네트워크 오류가 발생했습니다.');
        }
        this.docLoading = false; await this.service.render();
    }

    public async viewDocument(doc: any) {
        try {
            let res = await wiz.call("get_document", { doc_id: doc.id });
            if (res.code === 200) {
                this.selectedDoc = res.data.document;
                this.docViewerTotalPages = res.data.document.total_pages || 1;
                this.docViewerPage = 1;
                this.docViewerIsPdf = (this.selectedDoc.file_name || '').toLowerCase().endsWith('.pdf');
                await this.loadDocViewerPage();
            }
        } catch { }
        await this.service.render();
    }

    public async closeDocViewer() {
        this.selectedDoc = null;
        this.docViewerPage = 1;
        this.docViewerPageText = '';
        this.docViewerImageUrl = '';
        await this.service.render();
    }

    public async loadDocViewerPage() {
        this.docViewerLoading = true;
        await this.service.render();
        try {
            let res = await wiz.call("get_document_page", { doc_id: this.selectedDoc.id, page: this.docViewerPage });
            if (res.code === 200) {
                this.docViewerPageText = res.data.text || '';
                this.docViewerTotalPages = res.data.total_pages || 1;
            } else {
                // fallback: 전체 content를 1페이지로
                this.docViewerPageText = this.selectedDoc?.content || '텍스트를 불러올 수 없습니다.';
                this.docViewerTotalPages = 1;
            }
        } catch {
            this.docViewerPageText = this.selectedDoc?.content || '텍스트를 불러올 수 없습니다.';
            this.docViewerTotalPages = 1;
        }
        if (this.docViewerIsPdf) {
            try {
                let imgRes = await wiz.call("get_document_page_image", { doc_id: this.selectedDoc.id, page: this.docViewerPage });
                if (imgRes.code === 200 && imgRes.data.image) {
                    let mime = imgRes.data.mime || 'image/png';
                    this.docViewerImageUrl = `data:${mime};base64,${imgRes.data.image}`;
                } else {
                    this.docViewerImageUrl = '';
                }
            } catch {
                this.docViewerImageUrl = '';
            }
        } else {
            this.docViewerImageUrl = '';
        }
        this.docViewerLoading = false;
        await this.service.render();
    }

    public async docViewerPrev() {
        if (this.docViewerPage <= 1) return;
        this.docViewerPage--;
        await this.loadDocViewerPage();
    }

    public async docViewerNext() {
        if (this.docViewerPage >= this.docViewerTotalPages) return;
        this.docViewerPage++;
        await this.loadDocViewerPage();
    }

    public async docViewerGoPage(p: number) {
        if (p < 1 || p > this.docViewerTotalPages) return;
        this.docViewerPage = p;
        await this.loadDocViewerPage();
    }
    public async deleteDocument(doc: any, event: Event) {
        event.stopPropagation();
        if (!confirm(`"${doc.file_name}" 삭제?`)) return;
        try { let r = await wiz.call("delete_document", { doc_id: doc.id }); if (r.code === 200) await this.load(); } catch { }
    }

    public renderMarkdown(text: string): SafeHtml {
        if (!text) return '';
        let html = text
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/^### (.+)$/gm, '<div class="md-h3">$1</div>')
            .replace(/^## (.+)$/gm, '<div class="md-h2">$1</div>')
            .replace(/^# (.+)$/gm, '<div class="md-h1">$1</div>')
            .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
            .replace(/\*(.+?)\*/g, '<em>$1</em>')
            .replace(/^- \[x\] (.+)$/gm, '<div class="md-check done"><span>☑</span><span>$1</span></div>')
            .replace(/^- \[ \] (.+)$/gm, '<div class="md-check"><span>☐</span><span>$1</span></div>')
            .replace(/^- (.+)$/gm, '<div class="md-li"><span>•</span><span>$1</span></div>')
            .replace(/^(\d+)\. (.+)$/gm, '<div class="md-li"><span>$1.</span><span>$2</span></div>')
            .replace(/`([^`]+)`/g, '<code>$1</code>')
            .replace(/\n\n/g, '<div class="h-2"></div>')
            .replace(/\n/g, '<br>');
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    public isParsable(filename: string): boolean { if (!filename) return false; return ['pdf', 'hwp', 'hwpx', 'docx', 'zip'].includes((filename.toLowerCase().split('.').pop() || '')); }
    public getFileIcon(fn: string): string { const m: any = { pdf: 'fa-file-pdf', hwp: 'fa-file-alt', hwpx: 'fa-file-alt', docx: 'fa-file-word', zip: 'fa-file-archive' }; return m[(fn||'').toLowerCase().split('.').pop()||''] || 'fa-file'; }
    public getFileIconColor(fn: string): string { const m: any = { pdf: 'text-red-500', hwp: 'text-teal-600', hwpx: 'text-teal-600', docx: 'text-teal-700', zip: 'text-amber-500' }; return m[(fn||'').toLowerCase().split('.').pop()||''] || 'text-stone-400'; }
    public getDocStatus(filename: string): any { if (!this.item?.documents) return null; return this.item.documents.find((d: any) => d.file_name === filename || d.file_name === filename.replace(/[^\w가-힣.\-]/g, '_')); }
    public getDocTypeColor(dt: string): string { const m: any = { '제안요청서': 'bg-red-50 text-red-700 border-red-200', '과업지시서': 'bg-orange-50 text-orange-700 border-orange-200', '평가기준': 'bg-purple-50 text-purple-700 border-purple-200' }; return m[dt] || 'bg-stone-50 text-stone-600 border-stone-200'; }
    public formatFileSize(b: number): string { if (!b) return '-'; if (b >= 1048576) return (b / 1048576).toFixed(1) + ' MB'; if (b >= 1024) return (b / 1024).toFixed(0) + ' KB'; return b + ' B'; }
    public getDday(d: string): number | null { if (!d) return null; try { let dt = d.includes('-') ? new Date(d) : new Date(`${d.substring(0,4)}-${d.substring(4,6)}-${d.substring(6,8)}`); let now = new Date(); now.setHours(0,0,0,0); dt.setHours(0,0,0,0); return Math.ceil((dt.getTime()-now.getTime())/(86400000)); } catch { return null; } }
    public getDdayColor(d: number|null): string { if (d===null||d<0) return 'text-stone-400'; if (d<=3) return 'text-red-500'; if (d<=7) return 'text-orange-500'; if (d<=14) return 'text-yellow-600'; return 'text-emerald-600'; }
    public getDdayText(d: number|null): string { if (d===null) return '-'; if (d===0) return 'D-Day'; if (d>0) return `D-${d}`; return `D+${Math.abs(d)}`; }
    public formatBudget(a: number) { if (!a) return '-'; if (a>=100000000) return (a/100000000).toFixed(1)+'억원'; if (a>=10000) return (a/10000).toFixed(0)+'만원'; return a.toLocaleString()+'원'; }
    public formatDate(d: string) { if (!d||d.length<8) return '-'; if (d.includes('-')) return d.substring(0,10); return d.substring(0,4)+'-'+d.substring(4,6)+'-'+d.substring(6,8); }
}

export default PageAnalysisDetailComponent;